var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c("v-text-field", {
        ref: "input",
        attrs: {
          label: _vm.label,
          suffix:
            _vm.type !== null
              ? _vm.types.find(function(v) {
                  return v.value === _vm.type
                }).name
              : null,
          placeholder: _vm.type !== null ? null : "Wyłączone",
          readonly: _vm.type === null,
          rules: [
            function(v) {
              return _vm.type === null || !isNaN(parseInt(v)) || "Podaj liczbę"
            }
          ]
        },
        model: {
          value: _vm.count,
          callback: function($$v) {
            _vm.count = $$v
          },
          expression: "count"
        }
      }),
      _c(
        "v-btn",
        {
          staticClass: "my-3",
          attrs: { icon: "" },
          on: {
            click: function($event) {
              _vm.dialog = true
            }
          }
        },
        [_c("v-icon", [_vm._v(" fa-ellipsis-v ")])],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "300px" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: "Typ",
                      items: _vm.types,
                      "item-text": "name",
                      "item-value": "value"
                    },
                    model: {
                      value: _vm.type,
                      callback: function($$v) {
                        _vm.type = $$v
                      },
                      expression: "type"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v("OK")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }